// extracted by mini-css-extract-plugin
export default {"presenter-controls":"PresenterControls_presenter-controls__Ln2HY","presenter-controls--transparent":"PresenterControls_presenter-controls--transparent__FOdh7"};